import { __ } from '@wordpress/i18n';

export const types = [
	{ label: __('Chat', 'skype-button'), value: 'chat' },
	{ label: __('Call', 'skype-button'), value: 'call' },
	{ label: __('Chat & Call(Dropdown)', 'skype-button'), value: 'dropdown' }
];

export const sizes = [
	{ label: __('10px', 'skype-button'), value: 10 },
	{ label: __('12px', 'skype-button'), value: 12 },
	{ label: __('14px', 'skype-button'), value: 14 },
	{ label: __('16px', 'skype-button'), value: 16 },
	{ label: __('24px', 'skype-button'), value: 24 },
	{ label: __('32px', 'skype-button'), value: 32 },
];